import { render, staticRenderFns } from "./FlagsEditor.vue?vue&type=template&id=14c1e447"
import script from "./FlagsEditor.vue?vue&type=script&lang=js"
export * from "./FlagsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports